var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modalConfirmar",attrs:{"titulo":_vm.titulo,"adicional":_vm.adicional,"cancelar":_vm.cancelar},on:{"cancelar":_vm.toggle,"adicional":_vm.onAdicional}},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"my-3 f-16 justify-center text-center px-3"},[_vm._v(" "+_vm._s(_vm.mensaje)+" ")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }